/* eslint-disable no-param-reassign */
import {
  DOWNLOAD_ALL_DOC_RL_LOADING,
  DOWNLOAD_ALL_DOC_RL_DONE,
  DOWNLOAD_ALL_DOC_RL_ERROR
} from './actions'

export default {
  // download all document
  [DOWNLOAD_ALL_DOC_RL_LOADING] (state) {
    state.isLoadingDownloadAllDocRL = true
  },
  [DOWNLOAD_ALL_DOC_RL_DONE] (state, items) {
    state.downloadAllDocRL = items
    state.isLoadingDownloadAllDocRL = false
    state.errorDownloadAllDocRL = false
  },
  [DOWNLOAD_ALL_DOC_RL_ERROR] (state, error) {
    state.errorDownloadAllDocRL = error
    state.isLoadingDownloadAllDocRL = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/requestlist/mutations.js